import '/modules/common/css/ui/classified-summary-stats.css';
import '/modules/common/css/ui/classified-summary-stats.responsive.css';
import {formatNumber, nnTrim} from "../util";
import * as $ from "jquery";
import {isGraphicLowContrastOnWhite} from "../colors";
import {AbstractSimpleStatsShower} from "../ui/AbstractSimpleStatsShower";

/**
 * A simple stats shower for classified samples
 * @extends AbstractSimpleStatsShower
 */
class ClassifiedSummaryStats extends AbstractSimpleStatsShower {

    /**
     *
     * @param chartStyler {ChartStyler} A styler for the current data sample
     * @param data {Array<number|string>} The data to show stats for
     * @param id {string} Unique id of this UI element
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     **/
    constructor(chartStyler, data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig) {
        super(data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.chartStyler = chartStyler;
        this.labelFunction = this.chartStyler.getLabelFunction();
        this.colorFunction = this.chartStyler.getColorFunction();
        this.isNoDataFunction = this.chartStyler.getIsNoDataFunction();
    }

    getClassName() {
        return "ClassifiedSummaryStats";
    }

    _generateUIElements() {
        this.dataSummary = {};
        this.totalCount = 0;
        this.data.filter(v => !this.isNoDataFunction(v))
            .forEach(v => {
                const label = this.labelFunction(v);
                const color = this.colorFunction(v);
                if (!this.dataSummary[v] && label && color)
                    this.dataSummary[v] = {
                        color: color,
                        label: label,
                        count: 0
                    }
                if (this.dataSummary[v]) {
                    this.totalCount++;
                    this.dataSummary[v].count++;
                }
            });
        this.logDebug(this.totalCount)
        this.logDebug(JSON.stringify(this.dataSummary))

        Object.keys(this.dataSummary)
            .sort((v1, v2) => this.dataSummary[v2].count - this.dataSummary[v1].count)
            .slice(0, 3)
            .forEach(value => {
                const color = this.dataSummary[value].color;
                const lowContrastOnWhiteClass = isGraphicLowContrastOnWhite(color) ? 'low-contrast-white' : '';
                $('.stats-elements', this.uiElement).append($(
                    '<div class="stats-element">' +
                    '    <div class="' + lowContrastOnWhiteClass + ' color" style="background-color: ' + color + '"></div>' +
                    '    <div class="value">' + formatNumber(this.dataSummary[value].count / this.totalCount * 100, 2) + '%</div>' +
                    '</div>'
                ))
            });
        this.uiElement.addClass('classified');
    }


    _generateLegendElements(legendElem) {
        legendElem.append($('<table></table>')).addClass('classified');
        Object.keys(this.dataSummary)
            .sort((v1, v2) => this.chartStyler.getValueLegendIndex(v1) - this.chartStyler.getValueLegendIndex(v2))
            .forEach(value => {
                const color = this.dataSummary[value].color;
                const lowContrastOnWhiteClass = isGraphicLowContrastOnWhite(color) ? 'low-contrast-white' : '';
                $('table', legendElem).append($(
                    '<tr>' +
                    '    <td class="color ' + lowContrastOnWhiteClass + '" style="background-color: ' + color + '"></td>' +
                    '    <td class="label">' +
                    '        <label title="' + this.dataSummary[value].label + '">' + this.dataSummary[value].label + '</label>' +
                    '    </td>' +
                    '    <td class="value">' + formatNumber(this.dataSummary[value].count / this.totalCount * 100, 2) + '%</td>' +
                    '</tr>'
                ))
            });

    }
}

export {ClassifiedSummaryStats}